import * as amplitude from "@amplitude/analytics-browser";
import { ArrowFatRight, LockOpen } from "@phosphor-icons/react";
import { motion } from "motion/react";
import { useState } from "react";
import Tappable from "./tappable";

const LOCAL_STORAGE_KEY = "ig-valentine-unlocked";

export default function DownloadLocket({
  userName,
  onNext,
}: {
  userName: string;
  onNext: () => void;
}) {
  const [unlocked, setUnlocked] = useState(
    localStorage.getItem(LOCAL_STORAGE_KEY) === "true"
  );

  function handleDownloadClick() {
    amplitude.track("download_locket_clicked");

    setTimeout(() => {
      setUnlocked(true);
      localStorage.setItem(LOCAL_STORAGE_KEY, "true");
    }, 3_000);
  }

  return (
    <div className="h-full">
      <p className="text-center mx-4 mt-8 font-bold text-2xl text-brand-dark-pink leading-tight">
        Get out of
        <br />
        {userName}’{userName.endsWith("s") ? undefined : "s"} DMs and <br />
        onto their home screen
      </p>

      <div className="-mt-4">
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            type: "spring",
            duration: 0.75,
            bounce: 0.15,
            delay: 0.1,
          }}
        >
          <img src="/phone.png" alt="" className="w-full" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
          className="absolute inset-x-0 bottom-0 p-4 pt-16 bg-gradient-to-b from-transparent to-brand-light-pink"
        >
          {unlocked ? (
            <>
              <div className="text-brand-dark-pink flex items-center justify-center gap-x-2">
                <LockOpen weight="fill" />
                <p className="font-bold text-center text-lg">Unlocked!</p>
              </div>
              <div className="mt-3">
                <Tappable>
                  <button
                    className="w-full px-4 py-3 bg-brand-dark-pink text-white rounded-2xl flex items-center justify-center gap-x-3"
                    onClick={onNext}
                  >
                    <p className="text-2xl font-bold">See your 2nd Valentine</p>
                    <ArrowFatRight weight="fill" size={20} />
                  </button>
                </Tappable>
              </div>
            </>
          ) : (
            <>
              <p className="text-brand-dark-pink font-semibold text-center text-xl">
                To unlock your next two Valentines&hellip;
              </p>
              <div className="mt-3">
                <Tappable>
                  <a
                    href={
                      /iPhone|iPad/.test(navigator.userAgent)
                        ? "https://apps.apple.com/us/app/locket-widget/id1600525061?ppid=2866279e-a784-42c7-b0ec-d19f2e57343d"
                        : "https://locket.camera"
                    }
                    target="_blank"
                    className="w-full px-4 py-1 bg-brand-dark-pink rounded-2xl flex items-center justify-center gap-x-2"
                    onClick={handleDownloadClick}
                  >
                    <img
                      src="/locket-icon.png"
                      alt=""
                      className="h-12 translate-y-1"
                    />
                    <p className="text-2xl font-bold text-white">
                      Download Locket
                    </p>
                  </a>
                </Tappable>
              </div>
              <p className="mt-3 text-brand-dark-pink font-semibold text-center text-xl">
                &hellip;then come back to see them!
              </p>
            </>
          )}
        </motion.div>
      </div>
    </div>
  );
}
